import { render, staticRenderFns } from "./RiskProf.vue?vue&type=template&id=64c57dca&"
import script from "./RiskProf.vue?vue&type=script&lang=js&"
export * from "./RiskProf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports